import { COLOR } from "styles/style-constants"
import styled, { keyframes } from "styled-components"
import { BlueGradientButton } from "@rentspree/component-v2/dist/button/gradient"

const ButtonContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: inline-flex;
  ${(props) => props.width && `width:${props.width}`}
`
const ButtonGlowingAnimation = keyframes`
0% {
  transform: scale(0.75);
  opacity: 1;
}
70% {
  transform: scale(1);
  opacity: 0;
}
100% {
  transform: scale(0.75);
  opacity: 0;
}
`

const ButtonGlowingAnimationMobile = keyframes`
0% {
  transform: scale(0.913);
  opacity: 0.8;
}
70% {
  transform: scale(1);
  opacity: 0;
}
100% {
  transform: scale(0.913);
  opacity: 0;
}
`

const ButtonAnimation = styled.div`
  width: ${(props) => (props.width ? props.width : "145px")};
  height: 54px;
  position: absolute;
  background-color: ${COLOR.brightBlue};
  opacity: 0.2;
  z-index: 0;
  animation: ${(props) =>
    props.type === "mobile"
      ? ButtonGlowingAnimationMobile
      : ButtonGlowingAnimation};
  animation-duration: 1.4s;
  animation-delay: 1000ms;
  animation-timing-function: ease-out;
  animation-iteration-count: infinite;
  border-radius: 48px;
`

const ButtonWithAnimation = ({
  label,
  type,
  onClick,
  disabled,
  id,
  loading,
  width,
  animationType,
  ...rest
}) => (
  <ButtonContainer width={width} {...rest}>
    {!disabled && <ButtonAnimation width={width} type={animationType} />}
    <BlueGradientButton
      id={id}
      data-testid="button-with-animation"
      small
      semiBold
      width={width}
      margin="0"
      minWidth="109"
      fontSize="16px"
      hasIcon
      type={type}
      loading={loading}
      onClick={onClick}
      disabled={disabled}>
      {label}
    </BlueGradientButton>
  </ButtonContainer>
)
export default ButtonWithAnimation
